export default __webpack_public_path__ + "static/media/12334-7080-SASA-Celerio-Brochure-Update-min-1-58.8a41e238.pdf";